import React, { useEffect } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import './App.css';
import RequestPage from './components/RequestPage';
import NavigationBar from './components/NavigationBar';
import GetApisPage from './components/GetApisPage';
import RequestDocsPage from './components/RequestDocsPage';
import RequestMastersDocsPage from './components/RequestMastersDocsPage';
import RequestMastersPage from './components/RequestMastersPage';
import MastersPage from './components/MastersPage';
import IncidentDocsPage from './components/IncidentDocsPage';
import IncidentIndexPage from './components/IncidentIndexPage';
import IncidentPage from './components/IncidentPage';
import IncidentNavigationBar from './components/IncidentNavigationBar';
import ServiceRequestPage from './components/ServiceRequestPage';
import ServiceRequestDocsPage from './components/ServiceRequestDocsPage';
import GenericRequestPage from './components/GenericRequestPage';
import GenericRequestDocsPage from './components/GenericRequestDocsPage';
import ServiceCatalogPage from './components/ServiceCatalogPage';
import ServiceCatalogDocsPage from './components/ServiceCatalogDocsPage';
import ChangeRequestPage from './components/ChangeRequestPage';
import ChangeRequestDocsPage from './components/ChangeRequestDocsPage';
import CmdbPage from './components/CmdbPage';
import CmdbDocsPage from './components/CmdbDocsPage';
import WalkupPage from './components/WalkupPage'; 
import WalkupDocsPage from './components/WalkupDocsPage';
import KnowledgeBasePage from './components/KnowledgeBasePage';
import KnowledgeBaseDocsPage from './components/KnowledgeBaseDocsPage';
import OutagePage from './components/OutagePage';
import OutageDocsPage from './components/OutageDocsPage';
import ItsmMastersPage from './components/ItsmMastersPage';
import ItsmMastersDocsPage from './components/ItsmMastersDocsPage';
import ItsmGetApisPage from './components/ItsmGetApisPage';
import { useSso } from './contexts/SsoContext';

function NotAuthorized() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f8f8f8',
    }}>
      <img src="/images/LOGO_3.svg" alt="Wolken Logo" style={{ width: 120, marginBottom: 32 }} />
      <div style={{
        background: '#fff',
        padding: '2.5rem 2.5rem 2rem 2.5rem',
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        border: '2px solid #f93e3e',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 400,
      }}>
        <div style={{
          color: '#f93e3e',
          fontSize: '2.2rem',
          fontWeight: 700,
          marginBottom: 12,
          textAlign: 'center',
        }}>
          Access Denied
        </div>
        <div style={{
          color: '#444',
          fontSize: '1.1rem',
          textAlign: 'center',
        }}>
          You do not have access to this page.<br />
          Please contact your administrator if you believe this is a mistake.
        </div>
      </div>
    </div>
  );
}

function Home() {
  useEffect(() => {
    document.body.className = '';
    document.body.removeAttribute('style');
  }, []);

  return (
    <div className="home-root backgroud_page">
      <div className="main_page_items">
        <div className="wolken_logo">
          <img src="/images/LOGO_3.svg" alt="Wolken Logo" />
        </div>
        <div className="access_style">
          <Link to="/request" className="card_access">Access API's</Link>
        </div>
      </div>
      <div className="main_container">
        <div className="sub_container">
          <div className="main_headings">Empower</div>
          <div className="arrow_services">
            <div className="arrow_align">
              <img src="/images/ARROW.svg" alt="Arrow" />
            </div>
            <div className="main_services_style">
              <div className="services_style">your services</div>
              <div className="customer_style">with us</div>
            </div>
          </div>
          <div className="image_line">
            <img className="sm_image_line" src="/images/LINE.svg" alt="Line" />
          </div>
          <div className="line_style">Integrate Wolken API's to empower your business</div>
        </div>
        <div className="landing_page">
          <img src="/images/API_LANDING_PAGE_ILLUSTRATION.svg" alt="Landing Illustration" />
        </div>
      </div>
      <div className="row card_align">
        <div className="col-sm-6">
          <div className="background_card">
            <div className="card-body">
              <div className="img_card">
                <div className="wolken_care_content">
                  <img src="/images/API_WOLKEN_CARE_ILLUSTRATION.svg" alt="Care Illustration" />
                </div>
                <div className="card_body_align_items">
                  <p className="card-title">Customer Service Management</p>
                  <p className="card-text">Integrate Wolken API's to empower your business</p>
                  <Link className="card_access" to="/request">Access API's</Link>
                  <img src="/images/ARROW_RIGHT (1).svg" alt="Arrow Right" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="background_card">
            <div className="card-body card_body_align_items">
              <div className="img_card">
                <div className="wolken_illustration_content">
                  <img src="/images/API_ITSM_ILLUSTRATION.svg" alt="ITSM Illustration" />
                </div>
                <div className="card_body_align_items">
                  <p className="card-title">Enterprise Service Management</p>
                  <p className="card-text">Modernizing your IT/HR Management</p>
                  <Link className="card_access" to="/incident">Access API's</Link>
                  <img src="/images/ARROW_RIGHT (1).svg" alt="Arrow Right" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function App() {
  const { authError, loading } = useSso();
  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '4rem', fontSize: '1.5rem', color: '#888' }}>
        Loading...
      </div>
    );
  }
  return (
    authError ? (
      <NotAuthorized />
    ) : (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/request" element={<><NavigationBar /><RequestPage /></>} />
        <Route path="/get_apis" element={<><NavigationBar /><GetApisPage /></>} />
        <Route path="/request/docs" element={<><NavigationBar /><RequestDocsPage /></>} />
        <Route path="/request_masters/docs" element={<><NavigationBar /><RequestMastersDocsPage /></>} />
        <Route path="/request_masters" element={<><NavigationBar /><RequestMastersPage /></>} />
        <Route path="/masters" element={<><NavigationBar /><MastersPage /></>} />
        <Route path="/incident/docs" element={<><IncidentNavigationBar /><IncidentDocsPage /></>} />
        <Route path="/incident" element={<><IncidentNavigationBar /><IncidentIndexPage /></>} />
        <Route path="/incident/incident" element={<><IncidentNavigationBar /><IncidentPage /></>} />
        <Route path="/service_request" element={<><IncidentNavigationBar /><ServiceRequestPage /></>} />
        <Route path="/service_request/docs" element={<><IncidentNavigationBar /><ServiceRequestDocsPage /></>} />
        <Route path="/generic_request" element={<><IncidentNavigationBar /><GenericRequestPage /></>} />
        <Route path="/generic_request/docs" element={<><IncidentNavigationBar /><GenericRequestDocsPage /></>} />
        <Route path="/service_catalog" element={<><IncidentNavigationBar /><ServiceCatalogPage /></>} />
        <Route path="/service_catalog/docs" element={<><IncidentNavigationBar /><ServiceCatalogDocsPage /></>} />
        <Route path="/change_request" element={<><IncidentNavigationBar /><ChangeRequestPage /></>} />
        <Route path="/change_request/docs" element={<><IncidentNavigationBar /><ChangeRequestDocsPage /></>} />
        <Route path="/cmdb" element={<><IncidentNavigationBar /><CmdbPage /></>} />
        <Route path="/cmdb/docs" element={<><IncidentNavigationBar /><CmdbDocsPage /></>} />
        <Route path="/walkup" element={<><IncidentNavigationBar /><WalkupPage /></>} />
        <Route path="/walkup/docs" element={<><IncidentNavigationBar /><WalkupDocsPage /></>} />
        <Route path="/itsm_masters" element={<><IncidentNavigationBar /><ItsmMastersPage /></>} />
        <Route path="/itsm_masters/docs" element={<><IncidentNavigationBar /><ItsmMastersDocsPage /></>} />
        <Route path="/knowledge_base" element={<><IncidentNavigationBar /><KnowledgeBasePage /></>} />
        <Route path="/knowledge_base/docs" element={<><IncidentNavigationBar /><KnowledgeBaseDocsPage /></>} />
        <Route path="/outage" element={<><IncidentNavigationBar /><OutagePage /></>} />
        <Route path="/outage/docs" element={<><IncidentNavigationBar /><OutageDocsPage /></>} />
        <Route path="/itsm_get_apis" element={<><IncidentNavigationBar /><ItsmGetApisPage /></>} />
      </Routes>
    )
  );
}

export default App;
